const now = new Date();
const state = {
    clientH: document.documentElement.clientHeight-1 || document.body.clientHeight - 1,//可视区域高度
    clickName: 'wlmz',//主页侧边栏点击的item
    enterVideoList:[],//进入视频的会诊单ID列表
    enterVideoDdid:"",//进入视频订单id
    userInfo: {//当前用户
    },
    currentPatientId: "",//当前选中的患者ID
    currentConsultId: "",//当前操作的会诊单
    currentDoctorId: "1",//当前登录医生ID
    currentConsultList: null,//当前的选取的会诊单列表
    currentConsult: null,//当前操作的会诊单详情
    routerPath: "网络门诊",//header底部路由路径名称

    imageAmplifyObj: {},// 放大图片数组，用于左右按钮切换{ imgList, index },图片列表和当前点中的图片序号

    currentSessionId: "1",//当前登录用户ID
    /*会话数据*/
    messageList: [],//用户聊天内容列表
    patMessageList: [],// 医患关系聊天列表
    pushMsgConsultId: "",// 当前聊天窗id，如果当前id和推送id一致则获取消息列表
    pushMsgFollowId: "",// 当前医患关系聊天窗口
    /*设置数据*/
    //业务设置
    /*docVideoConsultStatus: () => this.userInfo.docVideoConsultStatus,//是否开通视频问诊
    docVideoConsultPrice: () => this.userInfo.docVideoConsultPrice,//视频问诊价格
    docPicConsultStatus: () => this.userInfo.docPicConsultStatus,//是否开通图文咨询
    docPicConsultPrice: () => this.userInfo.docPicConsultPrice,//图文咨询价格*/
    isMovePic: true,//图文咨询开个是否移动默认再右边为关闭状wdhz态
    isMoveVideo: true,//视频问诊开个是否移动默认在右边为关闭状态
    setUpClickName: "myInfo",//设置中心侧边栏点击的item
    //我的名片
    /**/
    /*远程会诊模块*/
    consultType: "ASS",//发起会诊时候选择会诊类型，ASS医-助-医还是DOC医医
    inviteVoList: [],//邀请医生列表
    sidebarTitle: "待处理",//医助端侧边栏顶部标题
    printDetail: {},// 打印页面详情
    /*我的患者模块*/
    patDetail: {},//患者详情
    patId: [],//当前点击的患者id，为了上传诊疗记录能够获得patId
    sysMedicalHistroyItem: {},//需要编辑修的诊疗记录项
    medicalEditType: "add",//上传修改诊疗记录弹出窗类型判断，add表示上传，edit表示编辑（需要把sysMedicalHistroyItem传入）
    checkFollowIdList: [],//群发消息时候选择的患者followID
    isOpenArticleListBox: false,// 是否打开文章列表
    pushPointMyPatientArr: localStorage.getItem("pushPoint") ? (JSON.parse(localStorage.getItem("pushPoint")).pushPointConsultIdArr ? JSON.parse(localStorage.getItem("pushPoint")).pushPointConsultIdArr : []) : [],// 当前推送的会话聊天followId数组(会有多个聊天推送), 用于显示列表中的红点
    /*文章发布模块*/
    articleList: [],//文章发布列表
    /*图文咨询模块*/
    currentPatientTab: "dhf",// 当前点击的列表tab页（dcl,dhf,yhf,ywc,yqx）, 为获取左侧列表准备
    /**
     * 推送状态
     */

    //消息盒子列表
    allMsgBoxList: {},// 获取全部消息列表内容
    allMsgBoxListCounts: 0,// 获取消息列表未读数量
    isOpenMsgListBox: false,// 是否打开消息盒子
    endConsultId: null,// 当前结束的问会诊id
    refreshConsultId: null,// 点击推送的前往按钮，如果刚好在当前页面无需跳转则刷新页面
    isGetNewMsg_yqys: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_yqys : false,// 邀请医生视频推送
    /*问诊推送*/
    //图文咨询推送
    isGetNewMsg_twzx: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_twzx : false,// 图文咨询侧边栏红点
    isGetNewMsg_twzx_dcl: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_twzx_dcl : false,// 获取新图文咨询待处理
    isGetNewMsg_twzx_dhf: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_twzx_dhf : false,// 获取新图文咨询待回复
    isGetNewMsg_twzx_ywc: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_twzx_ywc : false,// 获取新图文咨询已完成
    isGetNewMsg_twzx_yqx: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_twzx_yqx : false,// 获取新图文咨询已取消
    /*我的患者推送*/
    isGetNewMsg_wdhz: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_wdhz : false,// 我的患者侧边栏红点
    //视频问诊推送
    isGetNewMsg_spwz: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_spwz : false,// 视频问诊侧边栏红点
    isGetNewMsg_spwz_dcl: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_spwz_dcl : false,// 获得新视频问诊
    isGetNewMsg_spwz_bczl: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_spwz_bczl : false,// 补充资料
    isGetNewMsg_spwz_dwz: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_spwz_dwz : false,// 待问诊
    isGetNewMsg_spwz_ywc: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_spwz_ywc : false,// 已完成
    isGetNewMsg_spwz_yqx: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_spwz_yqx : false,// 已取消

    //远程会诊推送
    isGetNewMsg_ychz: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz : false,// 远程会诊侧边栏红点
    isGetNewMsg_ychz_wfq: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz_wfq : false,// 获得新远程会诊-我发起的
    isGetNewMsg_ychz_wsd: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz_wsd : false,// 获得新远程会诊-我收到的
    isGetNewMsg_ychz_ywc: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz_ywc : false,// 获得新远程会诊-已完成
    isGetNewMsg_ychz_yqx: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz_yqx : false,// 获得新远程会诊-已取消
    isGetNewMsg_ychz_bczl: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz_bczl : false,// 获得新远程会诊-补充了资料
    isGetNewMsg_ychz_yqbc: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz_yqbc : false,// 获得新远程会诊-要求补充资料

    /*会议中心*/
    refreshMtId: null,// 点击推送的前往按钮，如果刚好在当前页面无需跳转则刷新页面
    //会议中心推送
    isGetNewMsg_hyzx: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_hyzx : false,// 远程会诊侧边栏红点
    isGetNewMsg_ychz_dcj: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz_dcj : false,// 会议待参加
    isGetNewMsg_ychz_lshy: localStorage.getItem("pushPoint") ? JSON.parse(localStorage.getItem("pushPoint")).isGetNewMsg_ychz_lshy : false,// 历史会议
};

export default state;